import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUser, logout } from "./core/redux/authSlice";
import apiInstance from "./utility/apiInstance";

const AppInitializer: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const dispatch = useDispatch();
    const { token, userId, isAuthenticated } = useSelector(
        (state: any) => state.auth
    );
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                if (isAuthenticated && userId && token) {
                    const res = await apiInstance.get(`/api/users/${userId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    dispatch(updateUser(res.data.doc || res.data)); 
                }
            } catch (err) {
                console.error("Failed to fetch user:", err);
                dispatch(logout());
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [isAuthenticated, userId, token, dispatch]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading user...</span>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default AppInitializer;
